export class SaveCommunityVendorNotesParametersDto {
    communityVendorId: number;
    vendorCode: string;
    communityId: number;
    newNote: string;
}
